import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-lcl-hazard-disclaimer',
  templateUrl: './lcl-hazard-disclaimer.component.html',
  styleUrls: ['./lcl-hazard-disclaimer.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LclHazardDisclaimerComponent implements OnInit {
  @Input() public formGroup: UntypedFormGroup;

  public errors: any = {
    noHazardousGoodsClaimed: 'FORM_ERROR.CONFIRM_STATEMENT',
  };
  constructor() {}

  public ngOnInit(): void {}
}
